
import Moment from 'moment';

const _dateFormat = 'YYYY-MM-DD';
Moment.locale('en');

export function getCurrentDate(dateFormat: string = _dateFormat): string { return Moment(new Date()).format(dateFormat); }

export function parseDateToCalendarFormat(date: string): string {
    let parsedDate = '';
    try {
        parsedDate = Moment(date).format(_dateFormat);
        if (parsedDate == 'Invalid date')
            parsedDate = getCurrentDate();
    } catch (error) {
        console.log('Date parse error', error);
        parsedDate = getCurrentDate();
    }
    return parsedDate;
}

export function parseDateOrUndefined(date: string): string | undefined {
    let parsedDate = undefined;
    try {
        parsedDate = Moment(date).format(_dateFormat);
        if (parsedDate == 'Invalid date')
            parsedDate = undefined;
    } catch (error) {
        console.log('Date parse error', error);
    }
    return parsedDate;
}

export function parseDate(date: string): string {
    let parsedDate = '';
    try {
        parsedDate = Moment(date).format('MMM DD, YYYY');
        if (parsedDate == 'Invalid date')
            parsedDate = getCurrentDate('MMM DD, YYYY');
    } catch (error) {
        console.log('Date parse error', error);
        parsedDate = getCurrentDate();
    }
    return parsedDate;
}

